<template>
  <div id="app">
    <!-- MAP SPINNER -->
    <transition name="fade">
      <RingLoader
        v-if="$store.state.spinner"
        :color="'#eee'"
        :size="'50px'"
        id="map-spinner"
      ></RingLoader>
    </transition>
    <router-view/>
  </div>
</template>

<script>
import RingLoader from 'vue-spinner/src/RingLoader'

export default {
  name: 'App',
  components: {
    RingLoader
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue